import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { Layout, PageHeader } from "@/components/Layout";
import { Seo } from "@/components/Seo";
import { ZoomableImage } from "@/components/ZoomableImage";

export default function Merchandise() {
  const [site, setSite] = useState(null);

  useEffect(() => {
    api.get("/site").then((r) => setSite(r.data)).catch(() => {});
  }, []);

  const items = site?.merchandise || [];
  const email = site?.merch_email || "quintebca@gmail.com";

  return (
    <Layout>
      <Seo title="League Merchandise & Gear | Quinte BCA Pool League" description="Show your league pride with Quinte BCA Pool League merchandise — jerseys, shirts and custom gear available to order." path="/merchandise" />
      <PageHeader
        eyebrow="League gear"
        title="Merchandise"
        subtitle={site?.merch_intro || "Show your league pride! Browse our gear below."}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="mb-10">
          <a
            href={`mailto:${email}?subject=Quinte%20BCA%20Merchandise%20Inquiry`}
            data-testid="merch-email-btn"
            className="inline-flex items-center gap-2 bg-[#E11D2A] text-white rounded-md px-5 py-3 font-semibold hover:bg-[#c41320] transition-colors"
          >
            <Mail className="h-5 w-5" /> Email us to order — {email}
          </a>
        </div>

        {!site ? (
          <p className="text-[#555555]">Loading merchandise…</p>
        ) : items.length === 0 ? (
          <p className="text-[#555555]">Merchandise information is coming soon.</p>
        ) : (
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-testid="merch-grid">
            {items.map((m) => (
              <div
                key={m.id}
                data-testid={`merch-card-${m.id}`}
                className="group text-left bg-white rounded-xl border border-[#E5E7EB] shadow-sm overflow-hidden hover:shadow-lg transition-all"
              >
                <div className="relative bg-[#0B0B0C]">
                  {m.image ? (
                    <ZoomableImage
                      src={fileUrl(m.image)}
                      alt={m.caption || "Merchandise"}
                      testId={`merch-image-${m.id}`}
                      className="w-full h-auto object-contain"
                    />
                  ) : (
                    <div className="h-56 flex items-center justify-center text-gray-500 text-sm">No image</div>
                  )}
                </div>
                {m.caption && <p className="p-4 font-semibold text-[#111111]">{m.caption}</p>}
              </div>
            ))}
          </div>
        )}

        <div className="mt-14 rounded-xl border border-[#E5E7EB] bg-[#F5F8FF] p-8 text-center">
          <h2 className="font-heading text-2xl font-bold mb-2">Want something custom?</h2>
          <p className="text-[#555555] max-w-2xl mx-auto mb-5">
            Jerseys and t-shirts can be fully customized with your name, team and colours. Reach out for current pricing, sizing and order deadlines.
          </p>
          <a
            href={`mailto:${email}?subject=Quinte%20BCA%20Merchandise%20Inquiry`}
            data-testid="merch-email-btn-bottom"
            className="inline-flex items-center gap-2 border border-[#1E63C4] text-[#1E63C4] rounded-md px-5 py-3 font-semibold hover:bg-blue-50 transition-colors"
          >
            <Mail className="h-5 w-5" /> Contact us
          </a>
        </div>
      </div>
    </Layout>
  );
}
